module.exports = __webpack_public_path__ + "static/media/Massless_Spiral.bde7e670.png";